import { usePixelRenderer } from '@lib/renderers/pixel'
import { useCamera } from '@lib/systems/camera'
import { models } from '@game/models'

const {
  cameraPosition: camera
} = useCamera()

class Parallax {
  constructor () {
    this.canvas = undefined
    this.renderCallbacks = []
    this.renderQueue = {}
    this.renderParams = []
    this.center = {
      x: 0,
      y: 0
    }
    this.zHeight = 0.05
    this.perspective = 0.04
    this.renderModelHandler = this.renderModel.bind(this)
  }

  draw (ctx) {
    if (!this.canvas) return

    const cx = (this.canvas.width * this.center.x) + camera.x
    const cy = (this.canvas.height * this.center.y) + camera.y
    let zPos, id, fn, params

    for (let i = 0; i < this.renderCallbacks.length; i++) {
      this.renderCallbacks[i](this.renderModelHandler)
    }

    for (const z in this.renderQueue) {
      for (let i = 0; i < this.renderQueue[z].length; i++) {
        zPos = Number(z) * this.zHeight
        id = this.renderQueue[z][i].id
        fn = this.renderQueue[z][i].fn
        params = this.renderParams[id]

        params.px = (params.x - cx) * this.perspective
        params.x += zPos * params.px
        params.py = (params.y - cy) * this.perspective
        params.y += zPos * params.py

        fn(
          ctx,
          params.x,
          params.y,
          params.scale,
          params.color1,
          params.color2,
          params.params,
          zPos,
          params.px,
          params.py
        )
      }
      this.renderQueue[z].length = 0
    }

    this.renderParams.length = 0
  }

  renderModel (modelName, x, y, z, scale, color1, color2, params) {
    const id = this.renderParams.length

    this.renderParams.push({
      x,
      y,
      color1,
      color2,
      scale,
      params
    })

    let zPos
    for (const key in models[modelName]) {
      zPos = Number(key) + z
      if (!this.renderQueue[zPos]) this.renderQueue[zPos] = []
      this.renderQueue[zPos].push({
        id,
        fn: models[modelName][key]
      })
    }
  }
}

export const parallax = new Parallax()

export function enableParallax (canvas, cx, cy) {
  usePixelRenderer(function (ctx) {
    parallax.draw(ctx)
  }, {
    drawOrder: 100
  })

  parallax.canvas = canvas
  parallax.center.x = cx
  parallax.center.y = cy
}

export function useParallax (fn) {
  parallax.renderCallbacks.push(fn)
}
